import { useState, useEffect, useCallback } from "react";
import {
  Box,
  HStack,
  Pressable,
  ScrollView,
  Text,
  VStack,
  useMediaQuery,
} from "native-base";
import CryptoJS from "crypto-js";
import { Redirect } from "react-router-dom";
import { COLORS } from "../../utils/colors";
import MobileHeader from "../../layout/header/mobileHeader";
import WebHeader from "../../layout/header/webHeader";
import Breadcrumbs from "../../components/breadcrumb";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import CommonHeading from "../../components/headings";
import ViewUploadImageCards from "../../containers/viewUploadImageCards";
import ImageViewer from "../../components/imageViewer";
import CustomButton from "../../components/button";
import { photoSelectedTickSVG, photoTickIconSVG } from "../../utils/svg";
import { getAllImagesAPI } from "../../api/apis/event";
import { getWorkflowAPI, putReviewflowAPI, deleteImageReviewAPI } from "../../api/apis/workflow";
import { hasPermission } from "../../utils/permission";
import { Toaster } from "../../components/toaster";
import "./style.css";
import { PhotoDisplayFullScreen, VideoDisplayFullScreen } from "../requestEventDetailPage/photosListing/modalChildren";
import { getNotificationAPI } from "../../api/apis/notification";
import CustomModal from "../../components/modal";
import MobileModelSheet from "../../components/actionSheet";
import { useSelector } from "react-redux";
import { LoaderAnimation } from "../../components/spinner";
import config from "../../utils/config";

const PhotoApprovalPage = ({ title = "" }) => {
  const toaster = Toaster();
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("content"),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [redirect, setRedirect] = useState(false);

  const bytes1 = CryptoJS.AES.decrypt(
    sessionStorage.getItem("user_image"),
    config.imageKey
  );
  const jsonString1 = bytes1.toString(CryptoJS.enc.Utf8);
  const allImages = JSON.parse(jsonString1);

  const workflowId = allImages[0].workflow_id;
  const [workflow, setWorkflow] = useState({});

  const eventBytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("event"),
    config.eventKey
  );
  const eventString = eventBytes.toString(CryptoJS.enc.Utf8);
  const selectedEvent = JSON.parse(eventString);
  const [selectedImageIndex, setSelectedImageIndex] = useState([]);
  const eventTab = selectedEvent.type === "event" ? "Event" : "MICE";
  const breadcrumbDetails = {
    activeTab: { name: "Home", path: "/home" },
    activeMenu: { name: `${eventTab} Detail`, path: "/event-detail" },
    activeActivePage: {
      name: "Photos",
      path: "/event-detail/photo-detail",
    },
  };
  const [images, setImages] = useState(allImages);
  const [showModal, setShowModal] = useState(false);
  const [selectedImagePath, setSelectedImagePath] = useState("");
  const [showPopUpModal, setShowPopUpModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedVideo, setSelectedVideo] = useState("");
  const [showVideoModal, setShowVideoModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

  // User selection state (for non-admin users)
  const [userSelectedImages, setUserSelectedImages] = useState([]);
  const [showUserDeleteModal, setShowUserDeleteModal] = useState(false);

  // Check if current user has uploaded any of the images
  const userHasUploadedImages = images?.some(image => 
    image?.uploaded_email === userInfo?.email
  );

  // Show user selection controls if user has uploaded images and is not admin
  const shouldShowUserSelection = !hasPermission("REVIEW") && userHasUploadedImages;



  const getImages = async (workflow_id, event_id) => {
    let res = await getAllImagesAPI(workflow_id, event_id);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      //filter images based on status
      const filteredImages = res?.data?.data?.data?.filter(image => image?.status === "image_approval");
      // if filtered image is empty navigate to event detail page
      if (filteredImages.length === 0) {
        setRedirect(true);
        return;
      }
      setImages(filteredImages);
    }
  };

  useEffect(() => {
    if (workflowId && selectedEvent._id) {
      getImages(workflowId, selectedEvent._id);
    }
  }, [workflowId, selectedEvent._id]);
  // Get images uploaded by current user
  const getUserImages = () => {
    const filteredImages = images?.filter(source => 
      hasPermission("REVIEW") ||
      (!hasPermission("REVIEW") &&
        source.status === "image_approved") ||
      source.status === "image_approval"
    );
    return filteredImages?.filter(image => image?.uploaded_email === userInfo?.email) || [];
  };

 

  useEffect(() => {
    AddWorkflow();
  }, []);

  const AddWorkflow = async () => {
    let res = await getWorkflowAPI();
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      let workflows = {};
      res.data.data.data?.map((item) => {
        if (item.name === "EventWorkflow") {
          workflows["event"] = item;
        }
        if (item.name === "ImageWorkflow") {
          workflows["image"] = item;
        }
        if (item.name === "ReviewWorkflow") {
          workflows["review"] = item;
        }
      });
      setWorkflow(workflows);
      // if (
      //   workflows &&
      //   workflows["image"] &&
      //   workflows["image"]["_id"] &&
      //   selectedEvent &&
      //   selectedEvent._id
      // )
      //   getImages(workflows["image"]["_id"], selectedEvent._id);
    }
  };

  if (redirect) {
    return <Redirect to={"/event-detail"} />;
  }

  const handleSelectedImages = (index) => {
    const filteredImages = images?.filter(source => 
      hasPermission("REVIEW") ||
      (!hasPermission("REVIEW") &&
        source.status === "image_approved") ||
      source.status === "image_approval"
    );
    let selectInd = [];
    if (index === "select_all") {
      if (selectedImageIndex.length === filteredImages.length) selectInd = [];
      else selectInd = filteredImages.map((_, i) => i);
    } else {
      if (selectedImageIndex.length > 0 && selectedImageIndex.includes(index))
        selectInd = selectedImageIndex.filter((image) => image !== index);
      else selectInd = [...selectedImageIndex, index];
    }
    
    setSelectedImageIndex(selectInd);
  };

  // User selection handlers (for non-admin users)
  const handleUserSelectedImages = (index) => {
    const filteredImages = images?.filter(source => 
      hasPermission("REVIEW") ||
      (!hasPermission("REVIEW") &&
        source.status === "image_approved") ||
      source.status === "image_approval"
    );
    const userImages = getUserImages();
    const userImageIndices = userImages.map((_, i) => {
      const originalIndex = filteredImages.findIndex(img => img === userImages[i]);
      return originalIndex;
    }).filter(index => index !== -1);

    if (index === "select_all") {
      if (userSelectedImages.length === userImageIndices.length) {
        setUserSelectedImages([]);
      } else {
        setUserSelectedImages(userImageIndices);
      }
    } else {
      if (userSelectedImages.includes(index)) {
        setUserSelectedImages(userSelectedImages.filter(i => i !== index));
      } else {
        setUserSelectedImages([...userSelectedImages, index]);
      }
    }
  };



  const approvePhotoWorkflow = async (action_name) => {
    LoaderAnimation.show();
    if (selectedImageIndex.length === 0 && action_name === "REJECT_IMAGES") {
      let allDeleteData = [];
      images &&
        images.map((item, ind) => {
          let deletePayload = item;

          let id = deletePayload["_id"];
          deletePayload["workflow_instance_id"] = id;

          delete deletePayload["_id"];
          deletePayload.added_at = new Date();
          deletePayload.approved_at = new Date();
          deletePayload.approved_by = userInfo.user_id;

          allDeleteData.push(deletePayload);
        });
      if (allDeleteData.length > 0) {
        let res1 = await putReviewflowAPI(
          allDeleteData,
          workflow["image"]["_id"],
          "IMAGE_APPROVAL",
          selectedEvent._id,
          "REJECT_IMAGES"
        );
        if (res1.error) {
          toaster(res1.message, "error", "error");
          LoaderAnimation.hide();
          return;
        } else {
          if (allDeleteData.length == 0) {
            LoaderAnimation.hide();
            toaster("Updated Successfully", "success", "success");
          }
          getImages(workflowId, selectedEvent._id);
          setRedirect(true);
        }
      }
    } else if (
      selectedImageIndex.length === 0 &&
      action_name !== "REJECT_IMAGES"
    ) {
      toaster("Please select any image", "error", "error");
      LoaderAnimation.hide();
    } else {
      let allData = [];
      let allDeleteData = [];

      images &&
        images.map((item, ind) => {
          if (
            selectedImageIndex.includes(ind) &&
            action_name !== "REJECT_IMAGES"
          ) {
            let payload = item;

            let id = payload["_id"];
            payload["workflow_instance_id"] = id;

            delete payload["_id"];
            payload.approved_at = new Date();
            payload.added_at = new Date();

            payload.approved_by = userInfo.user_id;

            allData.push(payload);
          } else {
            let deletePayload = item;

            let id = deletePayload["_id"];
            deletePayload["workflow_instance_id"] = id;

            delete deletePayload["_id"];
            deletePayload.added_at = new Date();

            deletePayload.approved_at = new Date();
            deletePayload.approved_by = userInfo.user_id;

            allDeleteData.push(deletePayload);
          }
        });

      if (allData.length > 0) {
        let res = await putReviewflowAPI(
          allData,
          workflow["image"]["_id"],
          "IMAGE_APPROVAL",
          selectedEvent._id,
          "APPROVE_IMAGES"
        );
        if (res.error) {
          toaster(res.message, "error", "error");
          LoaderAnimation.hide();
          return;
        } else {
          LoaderAnimation.hide();
          toaster("Updated Successfully", "success", "success");
          getImages(workflowId, selectedEvent._id);
          setRedirect(true);
        }
      }

      if (allDeleteData.length > 0) {
        let res1 = await putReviewflowAPI(
          allDeleteData,
          workflow["image"]["_id"],
          "IMAGE_APPROVAL",
          selectedEvent._id,
          "REJECT_IMAGES"
        );
        if (res1.error) {
          toaster(res1.message, "error", "error");
          LoaderAnimation.hide();
          return;
        } else {
          if (allData.length == 0) {
            toaster("Updated Successfully", "success", "success");
          }
          getImages(workflowId, selectedEvent._id);
          setRedirect(true);
        }
      }
    }
    LoaderAnimation.hide();
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openPopUpModal = () => {
    setShowPopUpModal(true);
  };

  const closePopUpModal = () => {
    setShowPopUpModal(false);
  };

  const handleImages = (index, path) => {
    setSelectedImagePath(path);
    openModal();
  };

  const handleVideoClick = (videoUrl) => {
    setSelectedVideo(videoUrl);
    setShowVideoModal(true);
    // Scroll to top when video modal opens
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
    setSelectedVideo("");
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getModalTitle = () => {
    // if (selectedOption === "reject_images") {
    //   return <Text>Reject Images</Text>;
    // }
  };

  const getModalChildren = () => {
    if (selectedOption === "reject_images") {
      return (
        <Box justifyContent={"center"} alignItems={"center"} mt={"50px"}>
          <Text
            fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          >
            Are you sure, want to reject all the images?
          </Text>
        </Box>
      );
    } else if (selectedOption === "delete_images") {
      return (
        <Box justifyContent={"center"} alignItems={"center"} mt={"50px"}>
          <Text
            fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          >
            Are you sure, want to delete {selectedImageIndex.length} selected image{selectedImageIndex.length > 1 ? 's' : ''}?
          </Text>
        </Box>
      );
    }
  };

  const getModalFooter = () => {
    if (selectedOption === "reject_images") {
      return (
        <>
          {/* <Box
            width={MobileWindow && "50%"}
            justifyContent={MobileWindow && "center"}
            alignItems={MobileWindow && "center"}
          >
            <Text
              onPress={closePopUpModal}
              color={COLORS.MODAL_BACK_BUTTON_COLOR}
              fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
              mt={3}
              mr={12}
            >
              Back
            </Text>
          </Box> */}
          <Box width={MobileWindow && "100%"}>
            <CustomButton
              onPress={() => {
                closePopUpModal();
                approvePhotoWorkflow("REJECT_IMAGES");
              }}
              text="Confirm"
              color={COLORS.WHITE_COLOR}
            />
          </Box>
        </>
      );
    } else if (selectedOption === "delete_images") {
      return (
        <>
          <Box width={MobileWindow && "100%"}>
            <CustomButton
              onPress={() => {
                closeDeleteModal();
                deleteSelectedImages();
              }}
              text="Delete"
              color={COLORS.WHITE_COLOR}
              bgColor={COLORS.REJECT_TEXT_COLOR}
            />
          </Box>
        </>
      );
    }
  };

  const deleteSelectedImages = async () => {
    LoaderAnimation.show();
    
    if (selectedImageIndex.length === 0) {
      toaster("Please select any image to delete", "error", "error");
      LoaderAnimation.hide();
      return;
    }

    try {
      const filteredImages = images?.filter(source => 
        hasPermission("REVIEW") ||
        (!hasPermission("REVIEW") &&
          source.status === "image_approved") ||
        source.status === "image_approval"
      );
      
      const workflowInstanceIds = selectedImageIndex.map(index => filteredImages[index]._id);
      
      const payload = { workflow_instance_ids: workflowInstanceIds };
      
      const res = await deleteImageReviewAPI(payload);
      
      if (res.error) {
        toaster(res.message, "error", "error");
        LoaderAnimation.hide();
        return;
      } else {
        toaster("Images deleted successfully", "success", "success");
        setSelectedImageIndex([]);
        setShowDeleteModal(false);
        getImages(workflowId, selectedEvent._id);
      }
    } catch (error) {
      toaster("Error deleting images", "error", "error");
    } finally {
      LoaderAnimation.hide();
    }
  };

  const openDeleteModal = () => {
    if (selectedImageIndex.length === 0) {
      toaster("Please select any image to delete", "error", "error");
      return;
    }
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  // User delete functions (for non-admin users)
  const deleteUserSelectedImages = async () => {
    LoaderAnimation.show();
    
    if (userSelectedImages.length === 0) {
      toaster("Please select any image to delete", "error", "error");
      LoaderAnimation.hide();
      return;
    }

    try {
      const filteredImages = images?.filter(source => 
        hasPermission("REVIEW") ||
        (!hasPermission("REVIEW") &&
          source.status === "image_approved") ||
        source.status === "image_approval"
      );
      
      // Get the actual selected images from the filtered array
      const selectedImages = userSelectedImages.map(index => filteredImages[index]);
      const workflowInstanceIds = selectedImages.map(img => img._id);
      
      const payload = { workflow_instance_ids: workflowInstanceIds };
      
      const res = await deleteImageReviewAPI(payload);
      
      if (res.error) {
        toaster(res.message, "error", "error");
        LoaderAnimation.hide();
        return;
      } else {
        toaster("Images deleted successfully", "success", "success");
        setUserSelectedImages([]);
        setShowUserDeleteModal(false);
        getImages(workflowId, selectedEvent._id);
      }
    } catch (error) {
      toaster("Error deleting images", "error", "error");
    } finally {
      LoaderAnimation.hide();
    }
  };

  const openUserDeleteModal = () => {
    if (userSelectedImages.length === 0) {
      toaster("Please select any image to delete", "error", "error");
      return;
    }
    setShowUserDeleteModal(true);
  };

  const closeUserDeleteModal = () => {
    setShowUserDeleteModal(false);
  };

  const getUserModalChildren = () => {
    return (
      <Box justifyContent={"center"} alignItems={"center"} mt={"50px"}>
        <Text
          fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
        >
          Are you sure, want to delete {userSelectedImages.length} selected image{userSelectedImages.length > 1 ? 's' : ''}?
        </Text>
      </Box>
    );
  };

  const getUserModalFooter = () => {
    return (
      <>
        <Box width={MobileWindow && "100%"}>
          <CustomButton
            onPress={() => {
              closeUserDeleteModal();
              deleteUserSelectedImages();
            }}
            text="Delete"
            color={COLORS.WHITE_COLOR}
            bgColor={COLORS.REJECT_TEXT_COLOR}
          />
        </Box>
      </>
    );
  };



  return (
    <Box bg={COLORS.THEME_BACKGROUND} pb={8} minHeight={"100vh"}>
      <Box bg={COLORS.WHITE_COLOR}>
        {MobileWindow ? (
          <MobileHeader showTabs={false} />
        ) : (
          <>
            <WebHeader showTabs={false} />
            <Box p={4} px={"5rem"}>
              <Breadcrumbs path={breadcrumbDetails} />
            </Box>
          </>
        )}
      </Box>
      <VStack
        pt={7}
        pl={MobileWindow ? "3" : "6rem"}
        space={5}
        pb={hasPermission("REVIEW") && "50px"}
      >
        <CommonHeading text="Photos" />
        <Text
          fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          fontSize={"18px"}
        >
          {title}
        </Text>
        <ScrollView>
          <ImageViewer
            path
            images={images?.filter(source => 
              hasPermission("REVIEW") ||
              (!hasPermission("REVIEW") &&
                source.status === "image_approved") ||
              source.status === "image_approval"
            )}
            showSelectAll={false}
            showTopControls={false}
            externalSelectedImages={
              hasPermission("REVIEW") 
                ? (Array.isArray(selectedImageIndex) ? selectedImageIndex : []).map(index => {
                    const filteredImages = images?.filter(source => 
                      hasPermission("REVIEW") ||
                      (!hasPermission("REVIEW") &&
                        source.status === "image_approved") ||
                      source.status === "image_approval"
                    );
                    return {
                      index,
                      workflow_instance_id: filteredImages[index]?._id || index.toString()
                    };
                  })
                : (Array.isArray(userSelectedImages) ? userSelectedImages : []).map(index => {
                    const userImages = getUserImages();
                    return {
                      index,
                      workflow_instance_id: userImages[index]?._id || index.toString()
                    };
                  })
            }
            onSelectionChange={
              hasPermission("REVIEW") 
                ? (newSelection) => {
                    if (typeof newSelection === 'function') {
                      // If it's a function, call it with the current state
                      const currentSelection = Array.isArray(selectedImageIndex) ? selectedImageIndex : [];
                      const filteredImages = images?.filter(source => 
                        hasPermission("REVIEW") ||
                        (!hasPermission("REVIEW") &&
                          source.status === "image_approved") ||
                        source.status === "image_approval"
                      );
                      const result = newSelection(currentSelection.map(index => ({
                        index,
                        workflow_instance_id: filteredImages[index]?._id || index.toString()
                      })));
                      if (Array.isArray(result)) {
                        const indices = result.map(item => item.index);
                        setSelectedImageIndex(indices);
                      }
                    } else if (Array.isArray(newSelection)) {
                      const indices = newSelection.map(item => item.index);
                      setSelectedImageIndex(indices);
                    } else {
                      setSelectedImageIndex([]);
                    }
                  }
                : (newSelection) => {
                    if (typeof newSelection === 'function') {
                      // If it's a function, call it with the current state
                      const currentSelection = Array.isArray(userSelectedImages) ? userSelectedImages : [];
                      const userImages = getUserImages();
                      const result = newSelection(currentSelection.map(index => ({
                        index,
                        workflow_instance_id: userImages[index]?._id || index.toString()
                      })));
                      if (Array.isArray(result)) {
                        const indices = result.map(item => item.index);
                        setUserSelectedImages(indices);
                      }
                    } else if (Array.isArray(newSelection)) {
                      const indices = newSelection.map(item => item.index);
                      setUserSelectedImages(indices);
                    } else {
                      setUserSelectedImages([]);
                    }
                  }
            }
            onImagesDeleted={() => {
              // Refresh the images list
              if (workflow["image"] && workflow["image"]["_id"] && selectedEvent && selectedEvent._id) {
                getImages(workflow["image"]["_id"], selectedEvent._id);
              }
            }}
            onVideoClick={handleVideoClick}
          />
        </ScrollView>
      </VStack>
      
      {/* Bottom action bar - Admin controls */}
      {hasPermission("REVIEW") && (
        <HStack
          alignItems={"center"}
          bg={COLORS.WHITE_COLOR}
          w={"100%"}
          py={4}
          justifyContent={MobileWindow ? "center" : "flex-end"}
          space={MobileWindow ? 2 : 5}
          pr={MobileWindow ? 3 : 10}
          position={"fixed"}
          bottom={0}
        >
          <HStack>
            <input
              type="radio"
              className="selectall-input-radio"
              checked={selectedImageIndex.length === images?.filter(source => 
                hasPermission("REVIEW") ||
                (!hasPermission("REVIEW") &&
                  source.status === "image_approved") ||
                source.status === "image_approval"
              ).length}
              onClick={() => handleSelectedImages("select_all")}
            />
            <Text
              fontSize={
                MobileWindow
                  ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                  : COMMONFONTSIZE.LARGE_FONT_SIZE
              }
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
              color={COLORS.BLACK_COLOR}
            >
              Select All
            </Text>
          </HStack>
          {selectedImageIndex.length === 0 ? (
            <CustomButton
              onPress={() => {
                setSelectedOption("reject_images");
                openPopUpModal();
              }}
              text="Reject All"
              textColor={COLORS.REJECT_TEXT_COLOR}
              isOutline
              bgColor={COLORS.REJECT_TEXT_COLOR}
              fontSize={
                MobileWindow
                  ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                  : COMMONFONTSIZE.LARGE_FONT_SIZE
              }
            />
          ) : (
            <Box width={"00"}></Box>
          )}
          <CustomButton
            onPress={() => approvePhotoWorkflow("APPROVE_IMAGES")}
            text={`Approve ${selectedImageIndex.length}/${images?.filter(source => 
              hasPermission("REVIEW") ||
              (!hasPermission("REVIEW") &&
                source.status === "image_approved") ||
              source.status === "image_approval"
            ).length}`}
            bgColor={COLORS.THEME_COLOR}
            textColor={COLORS.WHITE_COLOR}
            fontSize={
              MobileWindow
                ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                : COMMONFONTSIZE.LARGE_FONT_SIZE
            }
          />
          <CustomButton
            onPress={() => {
              setSelectedOption("delete_images");
              openDeleteModal();
            }}
            text={`Delete ${selectedImageIndex.length > 0 ? selectedImageIndex.length : ''}`}
            bgColor={COLORS.REJECT_TEXT_COLOR}
            textColor={COLORS.WHITE_COLOR}
            fontSize={
              MobileWindow
                ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                : COMMONFONTSIZE.LARGE_FONT_SIZE
            }
          />
        </HStack>
      )}

      {/* Bottom action bar - User controls */}
      {shouldShowUserSelection && (
        <HStack
          alignItems={"center"}
          bg={COLORS.WHITE_COLOR}
          w={"100%"}
          py={4}
          justifyContent={MobileWindow ? "center" : "flex-end"}
          space={MobileWindow ? 2 : 5}
          pr={MobileWindow ? 3 : 10}
          position={"fixed"}
          bottom={0}
        >
          <HStack>
            <input
              type="radio"
              className="selectall-input-radio"
              checked={userSelectedImages.length === getUserImages().length}
              onClick={() => handleUserSelectedImages("select_all")}
            />
            <Text
              fontSize={
                MobileWindow
                  ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                  : COMMONFONTSIZE.LARGE_FONT_SIZE
              }
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
              color={COLORS.BLACK_COLOR}
            >
              Select All Media
            </Text>
          </HStack>
          <CustomButton
            onPress={() => {
              openUserDeleteModal();
            }}
            text={`Delete ${userSelectedImages.length > 0 ? userSelectedImages.length : ''}`}
            bgColor={COLORS.REJECT_TEXT_COLOR}
            textColor={COLORS.WHITE_COLOR}
            fontSize={
              MobileWindow
                ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                : COMMONFONTSIZE.LARGE_FONT_SIZE
            }
          />
        </HStack>
      )}



      {showModal && (
        <PhotoDisplayFullScreen
          selectedImage={selectedImagePath}
          setSelectedImage={setSelectedImagePath}
          closeModal={closeModal}
          h="90%"
        />
      )}
      {showVideoModal && (
        <VideoDisplayFullScreen
          selectedVideo={selectedVideo}
          setSelectedVideo={setSelectedVideo}
          closeModal={closeVideoModal}
          h="90%"
        />
      )}
      {!MobileWindow ? (
        <CustomModal
          top={"200px"}
          isOpen={showPopUpModal}
          onClose={closePopUpModal}
          header={getModalTitle()}
          body={getModalChildren()}
          footer={getModalFooter()}
          width={"35%"}
          height={"17rem"}
        />
      ) : (
        <MobileModelSheet
          isOpen={showPopUpModal}
          onClose={closePopUpModal}
          header={getModalTitle()}
          body={getModalChildren()}
          footer={getModalFooter()}
        />
      )}
      {!MobileWindow ? (
        <CustomModal
          top={"200px"}
          isOpen={showDeleteModal}
          onClose={closeDeleteModal}
          header={<Text>Delete Images</Text>}
          body={getModalChildren()}
          footer={getModalFooter()}
          width={"35%"}
          height={"17rem"}
          scrollToTop={scrollToTop}
        />
      ) : (
        <MobileModelSheet
          isOpen={showDeleteModal}
          onClose={closeDeleteModal}
          header={<Text>Delete Images</Text>}
          body={getModalChildren()}
          footer={getModalFooter()}
        />
      )}
      
      {/* User delete modal */}
      {!MobileWindow ? (
        <CustomModal
          isOpen={showUserDeleteModal}
          onClose={closeUserDeleteModal}
          header={<Text>Delete My Images</Text>}
          body={getUserModalChildren()}
          footer={getUserModalFooter()}
          width={"35%"}
          scrollToTop={scrollToTop}
        />
      ) : (
        <MobileModelSheet
          isOpen={showUserDeleteModal}
          onClose={closeUserDeleteModal}
          header={<Text>Delete My Images</Text>}
          body={getUserModalChildren()}
          footer={getUserModalFooter()}
          scrollToTop={scrollToTop}
        />
      )}
      

    </Box>
  );
};

export default PhotoApprovalPage;
